import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function BouncesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-br from-red-600 to-orange-500">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl sm:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Bounce House Rentals in Allentown PA
            </h1>
            <p className="text-xl text-white/95 max-w-3xl mx-auto">
              Premium inflatable bounce houses and slides for all ages. Clean, safe, and professionally maintained equipment delivered on time.
            </p>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
                  The Best Bounce House Rentals in the Lehigh Valley
                </h2>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  Fun Affairs offers the largest selection of bounce house rentals in Allentown, Bethlehem, and Easton PA. Our extensive collection includes themed bounce houses, combo units with slides, obstacle courses, and interactive inflatables perfect for any event.
                </p>
                <p className="text-base text-gray-600 mb-8 leading-relaxed">
                  Every bounce house is professionally cleaned and sanitized before delivery, safety-inspected, and set up by our experienced crew. We prioritize safety and cleanliness to give you peace of mind while your guests have a blast.
                </p>
                <Link 
                  to="/contact" 
                  className="inline-block bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap"
                >
                  Get Free Quote
                </Link>
              </div>
              <div>
                <img 
                  src="https://funaffairs.com/wp-content/uploads/2022/11/balloon-2.png"
                  alt="Bounce House Rentals"
                  className="w-full rounded-2xl shadow-2xl"
                />
              </div>
            </div>

            <div className="mb-24">
              <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center" style={{ fontFamily: 'Sora, sans-serif' }}>
                Why Choose Our Bounce Houses?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-sparkling-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Professionally Cleaned</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Every bounce house is thoroughly cleaned and sanitized before and after each rental using professional-grade equipment and solutions.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-shield-check-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Safety Inspected</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    All equipment undergoes rigorous safety inspections and meets or exceeds industry safety standards. We're fully licensed and insured.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-truck-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Professional Setup</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Our experienced crew handles delivery, setup, and pickup. We arrive on time and ensure everything is properly secured and ready.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-palette-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Themed Options</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Choose from a variety of themes and styles to match your event. From princess castles to superhero designs, we have it all.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-group-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">All Ages Welcome</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    We have bounce houses suitable for toddlers, kids, teens, and even adults. Multiple size options available.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-price-tag-3-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Competitive Pricing</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Fair, transparent pricing with no hidden fees. Get premium quality equipment at rates that fit your budget.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-12 text-center">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
                Ready to Book Your Bounce House?
              </h2>
              <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
                Contact Fun Affairs today for a free quote on bounce house rentals in Allentown, Bethlehem, Easton, and the Lehigh Valley.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link 
                  to="/contact" 
                  className="bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap w-full sm:w-auto"
                >
                  Get Free Quote
                </Link>
                <a 
                  href="tel:6102532835" 
                  className="bg-gray-900 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-gray-800 transition-colors whitespace-nowrap w-full sm:w-auto"
                >
                  <i className="ri-phone-fill mr-2"></i>
                  (610) 253-2835
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}